export default "<p>directors works!</p>\r\n"